var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCloseLeftSidebar(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 76,
    viewBox: "0 0 17 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.5 75.0657V0.934259L12.2697 7.44736C14.9125 9.20929 16.5 12.1755 16.5 15.3518V60.6482C16.5 63.8245 14.9125 66.7907 12.2697 68.5526L2.5 75.0657Z",
    fill: "#FCFCFC",
    stroke: "#DDDEDF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.12377 39.2765L10.1285 35.2717L10.875 36.0182L7.61667 39.2765L10.875 42.5349L10.1285 43.2813L6.12377 39.2765Z",
    fill: "#2F2F2F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseLeftSidebar);
export default __webpack_public_path__ + "static/media/CloseLeftSidebar.0930aa97a709680b56f67a9a9b769332.svg";
export { ForwardRef as ReactComponent };